exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard {\n  width: 90%;\n  max-width: 900px;\n  margin-top: 30px;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box; }\n  .dashboard .content {\n    background-color: #ffffff; }\n    .dashboard .content .tabs-content {\n      padding: 20px 40px; }\n\n@media (max-width: 480px) {\n  .dashboard .content .tabs-content {\n    padding: 10px 20px; } }\n\n@media (max-width: 400px) {\n  .dashboard .content .tabs-content {\n    padding: 5px 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/dashboard/dashboard.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/dashboard/dashboard.scss
// module chunks = index